import React, { useEffect, useState } from "react";
import { formatDate } from "../../utils/helper";

const HEADER_STORAGE_KEY = "selfReportHeaderData";

const HeaderPreview = ({
  showDateAndAuthor = true,
  apiData,
  respondentName,
  companyName,
  date,
  reportDataName,
  completionDate,
}) => {
  const [clientName, setClientName] = useState("");
  const [company, setCompany] = useState("");
  const [created, setCreated] = useState("");
  const [storedReportName, setStoredReportName] = useState("");
  const [storedCompletionDate, setStoredCompletionDate] = useState("");

  // Function to capitalize first letter of each word
  function capitalizeWords(str) {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }


  const storedHeader =
    sessionStorage.getItem(HEADER_STORAGE_KEY)
  const parsedStoredHeader = storedHeader ? JSON.parse(storedHeader) : null;

  const styles = {
    header: {
      position: "relative",
      top: "0px",
      left: "0px",
      right: "20px",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "space-between",
      borderBottom: "1px solid rgb(87, 149, 178)",
      paddingBottom: "7px",
      width: "100%",
      boxSizing: "border-box",
      zIndex: 10,
    },
    leftSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    title: {
      fontSize: "11px",
      fontFamily: "Helvetica, sans-serif",
      lineHeight: "24px",
      color: "#5795B2",
      font: "Bold",
      fontWeight: 700,
      textTransform: "uppercase",
      margin: "0",
      letterSpacing: "0px",
      lineHeight: "15px"
    },
    subtitle: {
      fontSize: "12px",
      fontFamily: "Helvetica, sans-serif",
      // lineHeight: "24px",
      color: "#5795B2",
      fontWeight: 400,
      margin: "0",
      letterSpacing: "0px",
      lineHeight: "16px"
    },
    rightSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      textAlign: "right",
      lineHeight: "14px",
      gap: "1px"
    },
    detailName: {
      fontSize: "10px",
      fontFamily: "Helvetica, sans-serif",
      color: "#5795B2",
      fontWeight: 700,
      margin: "0",
      letterSpacing: "0px",
      whiteSpace: "nowrap",
      font: "Bold",

    },
    detailText: {
      fontSize: "10px",
      fontFamily: "Helvetica, sans-serif",
      color: "#5795B2",
      fontWeight: 400,
      margin: "0",
      letterSpacing: "0px",
      whiteSpace: "nowrap",
      font: "Bold",

    },
  };

  const displayName = parsedStoredHeader?.respondentName || parsedStoredHeader?.reportDataName;
  const displayCompany = parsedStoredHeader?.companyName || apiData?.companyName;
  const displayDate = parsedStoredHeader?.completionDate || parsedStoredHeader?.date;

  return (
    <div style={styles.header}>
      <div style={styles.leftSection}>
        <p style={styles.title}>QUADRANT FLOW</p>
        <p style={styles.subtitle}>Life & Leadership Assessment</p>
      </div>
      {showDateAndAuthor && (
        <div style={styles.rightSection}>
          <p style={styles.detailName} className="capitalize">
            {displayName}
          </p>
          <p style={styles.detailText} className="capitalize">
            {displayCompany}
          </p>
          <p style={styles.detailText}>{formatDate(displayDate)}</p>
        </div>
      )}
    </div>
  );
};

export default HeaderPreview;
